/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */

import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import CurrencySign from 'components/price/CurrencySign.component';
import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';
import currencySign from 'utils/intl/currencySign.util';
import C from 'utils/values/constant.util';
import fixed from 'utils/values/fixed.util';

import { DownloadExcelButton } from 'reports/Common/DownloadExcelButton';
import { convertToMoneyAfterVat } from 'reports/utils';

import CN from './RevenueCommissionTable.module.scss';

const colWidth = '140px';

const categoriesMap = (t) => ({
  NO_SHOW: t('businessReports.commissions.categoryTypes.noShow'),
  TOTAL_SERVICES: t('businessReports.commissions.categoryTypes.totalServices'),
  TOTAL: t('businessReports.commissions.categoryTypes.total'),
  RETAIL: t('businessReports.commissions.categoryTypes.retail'),
});

const translatedCategories = (t) =>
  C({
    totalServicesName: t('businessReports.commissions.totalServicesName'),
    totalName: t('businessReports.commissions.totalName'),
  });

const translatedHeaders = (t) =>
  C({
    categories: t('businessReports.commissions.categories'),
    revenueExclTips: t('businessReports.commissions.revenueExclTips'),
    staffCommission: t('businessReports.commissions.staffCommission'),
    staffRevenue: t('businessReports.commissions.staffRevenue'),
    businessRevenue: t('businessReports.commissions.businessRevenue'),
  });

class RevenueCommissionTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commissionForAllStylist: {},
    };
  }

  componentDidMount() {
    let commissionArr = [];
    if (this.props.allCommissionReport) {
      if (Object.keys(this.props.allCommissionReport).length) {
        commissionArr = Object.entries(this.props.allCommissionReport);
      }
    }

    this.props.data.map((rev) => {
      const categories = rev.categories;
      const products = rev.products;
      const id = rev.id;
      const revenue_from_no_shows = rev.revenue_from_no_shows;
      const revenue_from_products = rev.revenue_from_products;
      const oneCommission = commissionArr.filter((c) => c[0] === rev.name);
      let commission;
      if (oneCommission.length > 0) {
        commission = oneCommission[0];
      }
      setTimeout(() => {
        this.makeCommissionArr(categories, products, commission, revenue_from_no_shows, revenue_from_products, id, rev.name);
      }, 0);
    });
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    let commissionArr = [];
    if (nextProps.allCommissionReport) {
      if (Object.keys(nextProps.allCommissionReport).length) {
        commissionArr = Object.entries(nextProps.allCommissionReport);
      }
    }

    nextProps.data.map((rev) => {
      const categories = rev.categories;
      const products = rev.products;
      const id = rev.id;
      const revenue_from_no_shows = rev.revenue_from_no_shows;
      const revenue_from_products = rev.revenue_from_products;
      const oneCommission = commissionArr.filter((c) => c[0] === rev.name);
      let commission;
      if (oneCommission.length > 0) {
        commission = oneCommission[0];
      }
      setTimeout(() => {
        this.makeCommissionArr(categories, products, commission, revenue_from_no_shows, revenue_from_products, id, rev.name);
      }, 0);
    });
  }

  getCommissionId = (commissionRatesOne, object_id) => {
    if (commissionRatesOne) {
      for (let i = 0; i < commissionRatesOne.length; i += 1) {
        if (commissionRatesOne[i].object_type === 'category') {
          if (commissionRatesOne[i].object_id === object_id) {
            return commissionRatesOne[i].id;
          }
        }
      }
    }
    return -1;
  };
  getCommissionRate = (oneCommissionRates, object_id) => {
    if (oneCommissionRates) {
      const comArr = oneCommissionRates.filter((c) => c.object_type === 'category' && c.object_id === object_id);
      let newRate = 0;
      if (comArr.length) {
        newRate = comArr[0].percentage;
      }
      return newRate;
    }
    return 0;
  };

  makeCommissionArr = (categories, products, commissionArray, revenue_from_no_shows, revenue_from_products, stylistId, stylistName) => {
    const safeRevenueFromNoShows = revenue_from_no_shows || 0;
    const safeRevenueFromProducts = revenue_from_products || 0;

    const CATEGORY_TYPES = categoriesMap(this.props.t);

    const categoryArr = Object.values(categories);
    const commissionObj = {};
    let totalServiceRevenue = 0;
    let totalServiceCommission = 0;
    let allCommissionRates = [];
    if (commissionArray && commissionArray.length > 0) {
      allCommissionRates = commissionArray[1];
    }

    if (categoryArr.length > 0) {
      for (let i = 0; i < categoryArr.length; i += 1) {
        const object_id = categoryArr[i].id;
        const commissionRate = this.getCommissionRate(allCommissionRates, object_id); // % commission
        // price should be total, backend name error
        const ItemRevenue = categoryArr[i].price; // exampl price for service "Hair cut"
        const businessShare = ItemRevenue * (1 - commissionRate); //  price * (100% of revenue - 0.3) // 30%

        totalServiceRevenue += ItemRevenue;
        const commission = ItemRevenue * commissionRate;
        totalServiceCommission += commission;
        commissionObj[categoryArr[i].name] = {
          stylistId,
          object_id,
          id: this.getCommissionId(allCommissionRates, object_id),
          ItemRevenue,
          commissionRate,
          commission,
          businessShare,
          object_type: 'category',
        };
      }
    }
    if (Object.values(commissionObj).length) {
      commissionObj[CATEGORY_TYPES.TOTAL_SERVICES] = {
        ItemRevenue: totalServiceRevenue,
        commissionRate: '-',
        commission: totalServiceCommission,
        businessShare: totalServiceRevenue - totalServiceCommission,
      };
    }

    const priceList = Object.values(products).map((p) => p.price);
    const totalRetail = priceList.length ? priceList.reduce((a, total) => total + a) : 0;
    let retailCommission = 0;
    let noshowCommission = 0;

    if (commissionArray && commissionArray[1] && commissionArray.length && commissionArray[1].length) {
      for (let i = 0; i < allCommissionRates.length; i += 1) {
        if (allCommissionRates[i].object_type === 'all_products') {
          const cRate = allCommissionRates[i].percentage ? allCommissionRates[i].percentage : 0;
          retailCommission = totalRetail * cRate;
          commissionObj[CATEGORY_TYPES.RETAIL] = {
            object_id: allCommissionRates[i].id,
            id: allCommissionRates[i].id ? allCommissionRates[i].id : -1,
            stylistId,
            object_type: allCommissionRates[i].object_type,
            ItemRevenue: safeRevenueFromProducts,
            commissionRate: allCommissionRates[i].percentage,
            commission: retailCommission,
            businessShare: safeRevenueFromProducts - retailCommission, //
          };
        } else if (allCommissionRates[i].object_type === 'no_show') {
          const cRate = allCommissionRates[i].percentage ? allCommissionRates[i].percentage : 0;
          noshowCommission = safeRevenueFromNoShows * cRate;
          commissionObj[CATEGORY_TYPES.NO_SHOW] = {
            object_id: allCommissionRates[i].id,
            id: allCommissionRates[i].id ? allCommissionRates[i].id : -1,
            stylistId,
            object_type: allCommissionRates[i].object_type,
            ItemRevenue: safeRevenueFromNoShows,
            commissionRate: allCommissionRates[i].percentage,
            commission: noshowCommission,
            businessShare: safeRevenueFromNoShows - noshowCommission, //
          };
        }
      }
    }

    if (!commissionObj[CATEGORY_TYPES.RETAIL]) {
      commissionObj[CATEGORY_TYPES.RETAIL] = {
        object_id: 0,
        id: -1,
        stylistId,
        object_type: 'all_products',
        ItemRevenue: safeRevenueFromProducts,
        commissionRate: 0,
        commission: 0,
        businessShare: safeRevenueFromProducts,
      };
    }

    if (!commissionObj[CATEGORY_TYPES.NO_SHOW]) {
      commissionObj[CATEGORY_TYPES.NO_SHOW] = {
        object_id: 0,
        id: -1,
        stylistId,
        object_type: 'no_show',
        ItemRevenue: safeRevenueFromNoShows,
        commissionRate: 0,
        commission: 0,
        businessShare: safeRevenueFromNoShows,
      };
    }

    const totalRevenue = totalServiceRevenue + safeRevenueFromProducts + safeRevenueFromNoShows;
    const totalCommission = totalServiceCommission + retailCommission + noshowCommission;

    const totalBusinessShare = Object.values(commissionObj)
      .filter((item) => !!item.object_type) //include all 'category' , 'all_products', 'no_show'
      .reduce((sum, item) => {
        const rounded = Math.round(item.businessShare * 100) / 100;
        return sum + rounded;
      }, 0);

    // Staff table - Total row
    commissionObj[CATEGORY_TYPES.TOTAL] = {
      ItemRevenue: totalRevenue, // incl. 'Total' | 'Retail' |	'No-show fees'
      commissionRate: '-',
      commission: totalCommission, // incl. 'Total' | 'Retail' |	'No-show fees'
      businessShare: totalBusinessShare, // incl. all  but exclude 'Total Services'
    };

    const { commissionForAllStylist } = this.state;

    const copyOfCommissionForAllStylist = Object.assign({}, commissionForAllStylist);

    copyOfCommissionForAllStylist[stylistName] = commissionObj;
    this.setState({ commissionForAllStylist: copyOfCommissionForAllStylist });
  };

  transformCommissionRate = (rate) => (rate !== '-' ? `${fixed(Number(rate) * 100)}%` : '-');

  createCsv = (data) => {
    const TABLE_HEADERS = translatedHeaders(this.props.t);

    const dataArray = Array.isArray(data) ? data : Object.keys(data).map((k) => ({ [k]: data[k] }));

    const convertValue = (value) => currencySign({ value: convertToMoneyAfterVat(value), currentSalonAbbr: this.props.currency });

    return dataArray.reduce((acc, categoryGroup) => {
      const categoryNames = Object.keys(categoryGroup);

      const rows = categoryNames.map((category) => {
        const item = categoryGroup[category];

        return {
          [TABLE_HEADERS.categories]: category,
          [TABLE_HEADERS.revenueExclTips]: convertValue(item.ItemRevenue),
          [TABLE_HEADERS.staffCommission]: this.transformCommissionRate(item.commissionRate),
          [TABLE_HEADERS.staffRevenue]: convertValue(item.commission),
          [TABLE_HEADERS.businessRevenue]: convertValue(item.businessShare),
        };
      });

      return acc.concat(rows);
    }, []);
  };

  render() {
    const commissionsArr = Object.entries(this.state.commissionForAllStylist);
    const TABLE_HEADERS = translatedHeaders(this.props.t);
    const NO_TYPE_CATEGORY = translatedCategories(this.props.t);

    const allCategories = {};

    for (const [, data] of commissionsArr) {
      for (const [catName, catData] of Object.entries(data)) {
        if (!allCategories[catName]) {
          allCategories[catName] = {
            catName,
            object_type: catData?.object_type || null,
          };
        }
      }
    }

    // normal categories with object_type
    const normalCategories = Object.values(allCategories)
      .filter((c) => c.object_type)
      .map((c) => c.catName);

    // all categories + 'Total Services' and 'Total' at the end in a specific order
    const categoriesArray = [...normalCategories, NO_TYPE_CATEGORY.totalServicesName, NO_TYPE_CATEGORY.totalName];

    return (
      <div id="commissions-stylist" className={CN.component}>
        <div className="t-bgr fullWidth">
          <div className="t-wrap">
            <h2>{this.props.t('businessReports.commissions.totalBusinessRevenueShare')}</h2>
            <div className="t-discount">
              <table
                className={cn({
                  businessSummaryTable: true,
                  [CN.boldFooterRow]: true,
                })}
              >
                <tbody>
                  <tr>
                    <td colSpan="3">
                      <div className="date-in-tbl-for-export">
                        {this.props.t('businessReports.commissions.fromDate')} <strong>{this.props.startDate}</strong> {this.props.t('businessReports.commissions.toDate')}{' '}
                        <strong>{this.props.endDate}</strong>
                      </div>
                    </td>
                  </tr>
                  <tr className="t-h first-row">
                    <th className="a3 h" style={{ width: '220px' }}>
                      {TABLE_HEADERS.categories}
                    </th>
                    <th className="a3 text-r" style={{ width: colWidth, paddingLeft: '20px' }}>
                      <span className="column-title">{this.props.t('businessReports.commissions.businessRevenueShare')}</span>
                    </th>
                    <th style={{ width: 'auto' }} />
                  </tr>
                  {categoriesArray.map((cat) => {
                    const totalShare = commissionsArr.reduce((sum, [, data]) => sum + (data[cat]?.businessShare || 0), 0);
                    if (totalShare === 0) return null;
                    return (
                      <tr className="t-h" key={cat}>
                        <td className="stylist-name">{cat}</td>
                        <td className="t-value">
                          <CurrencySign /> {convertToMoneyAfterVat(totalShare)}
                        </td>
                        <td />
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {[...commissionsArr].map((commission, index) => {
          const [stylistName, data] = commission || [];
          return (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`${index}-${stylistName}`} className="t-bgr fullWidth">
              <div className="t-wrap">
                <div className={CN.tableHeader}>
                  <h2>{stylistName}</h2>
                  <DownloadExcelButton getCsvData={() => this.createCsv(data)} fileName={this.props.t('businessReports.commissions.commissionFor', { stylist: stylistName })} disabled={!data} />
                </div>
                <div className="t-discount cfix not-footer">
                  <table
                    id={`table-to-xls-${stylistName}`}
                    className={cn({
                      'discount-tbl with-input-percent': true,
                      [CN.boldFooterRow]: true,
                    })}
                  >
                    <tbody>
                      <tr>
                        <td colSpan="3">
                          <div className="date-in-tbl-for-export">
                            {this.props.t('businessReports.commissions.fromDate')}
                            {S.space}
                            <strong>{this.props.startDate}</strong> {this.props.t('businessReports.commissions.toDate')}
                            {S.space}
                            <strong>{this.props.endDate}</strong>
                          </div>
                        </td>
                      </tr>
                      <tr className="t-h first-row">
                        <th className="a3 h" style={{ width: '220px' }}>
                          {TABLE_HEADERS.categories}
                        </th>
                        <th className="a3 text-r" style={{ width: '120px', paddingLeft: '20px' }}>
                          <span className="bubble">
                            <span className="tooltip">
                              <div />
                            </span>
                          </span>
                          <span className="column-title">{TABLE_HEADERS.revenueExclTips}</span>
                        </th>
                        <th className="a3 text-r" style={{ width: colWidth }}>
                          <span className="bubble">
                            <span className="tooltip">
                              <div />
                            </span>
                          </span>
                          <span className="column-title">{TABLE_HEADERS.staffCommission}</span>
                        </th>
                        <th className="a3 text-r" style={{ width: colWidth }}>
                          <span className="bubble">
                            <span className="tooltip">
                              <div />
                            </span>
                          </span>
                          <span className="column-title">{TABLE_HEADERS.staffRevenue}</span>
                        </th>
                        <th className="a3 text-r" style={{ width: colWidth }}>
                          <span className="column-title">{TABLE_HEADERS.businessRevenue}</span>
                        </th>
                        <th style={{ width: 'auto' }} />
                      </tr>
                      {commission &&
                        Object.entries(data).length > 0 &&
                        Object.entries(data).map((cat) => (
                          <tr className="t-h" key={`${cat[0]}`}>
                            <td className="stylist-name">{cat[0]}</td>
                            <td data-bem="RevenueCommissionTable-revenue-excl-tips" className="t-value">
                              <CurrencySign />
                              {convertToMoneyAfterVat(cat[1].ItemRevenue)}
                            </td>
                            <td className="t-value low">{this.transformCommissionRate(cat[1].commissionRate)}</td>
                            <td data-bem="RevenueCommissionTable-staff-revenue-share" className="t-value" style={{ paddingLeft: '34px' }}>
                              <CurrencySign /> {convertToMoneyAfterVat(cat[1].commission)}
                            </td>
                            <td data-bem="RevenueCommissionTable-business-revenue-share" className="t-value" style={{ paddingLeft: '34px' }}>
                              <CurrencySign /> {convertToMoneyAfterVat(cat[1].businessShare)}
                            </td>
                            <td />
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          );
        })}
        <br /> <br /> <br />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currency: selectCurrentSalonCurrency(state),
});

const RevenueCommissionTableHoc = connect(mapStateToProps)(withTranslation()(RevenueCommissionTable));

export default RevenueCommissionTableHoc;
